module.exports = __webpack_public_path__ + "static/media/ApplyChanges.8e290dc3.png";